var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3411",
    "data-name": "Rectangle 3411",
    width: 24,
    height: 24,
    transform: "translate(1425 21)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4680",
    "data-name": "Mask Group 4680",
    transform: "translate(-1425 -21)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(213 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(1218.6 18.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M85.991,0a.461.461,0,0,0,.049.019.668.668,0,0,1,.52.669q0,1.3,0,2.594,0,1.228,0,2.457v.133c.042-.039.07-.062.1-.088.381-.38.757-.764,1.142-1.139a.675.675,0,1,1,.929.979q-.9.9-1.8,1.8c-.181.181-.362.364-.545.544a.673.673,0,0,1-1,0q-1.176-1.173-2.349-2.348a.658.658,0,0,1-.188-.675.634.634,0,0,1,.49-.473.661.661,0,0,1,.655.195q.559.56,1.118,1.119a.8.8,0,0,1,.069.092l.033-.016v-.12c0-1.627.007-3.255,0-4.882A.766.766,0,0,1,85.759,0Z",
    transform: "translate(-80.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M10.8,336.123a1.661,1.661,0,0,1-.088.223.658.658,0,0,1-.567.345c-.025,0-.049,0-.074,0H.727a.676.676,0,1,1-.094-1.348c.046,0,.091,0,.137,0H9.976a.706.706,0,0,1,.824.569Z",
    transform: "translate(0 -325.894)",
    fill: "#0a64f9"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f8df14cb802b96f6af73af6b381dea39.svg";
export { ForwardRef as ReactComponent };